{
  "name": "test-accelerator",
  "version": "0.0.6",
  "private": true,
  "description": "Test accelerator",
  "main": "electron.main.js",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "electron": "electron .",
    "start:electron": "concurrently -n WEB,DESKTOP \"npm:start\" \"wait-on http://localhost:4200 && cross-env ELECTRON_START_URL=http://localhost:4200 ELECTRON_ENV=local-dev electron .\"",
    "start:electron:dev": "cross-env ELECTRON_ENV=dev electron .",
    "start:electron:prod": "cross-env ELECTRON_ENV=prod electron .",
    "runner:local": "cross-env ELECTRON_ENV=local-dev electron . --mode=runner",
    "build:desktop:dev": "ng build --configuration dev",
    "build:desktop:test": "ng build --configuration test",
    "build:desktop:prod": "ng build --configuration prod",
    "postinstall": "node ./scripts/postinstall.js",
    "clean:dist": "rimraf dist/test-accelerator .angular/cache",
    "package:win": "npm run clean:dist && cross-env CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win -c.extraMetadata.buildChannel=dev",
    "package:win:dev": "npm run clean:dist && npm run build:desktop:dev && cross-env CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win -c.extraMetadata.buildChannel=dev",
    "package:win:test": "npm run clean:dist && npm run build:desktop:test && cross-env ELECTRON_ENV=test CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win -c.extraMetadata.buildChannel=test",
    "package:win:prod": "npm run clean:dist && npm run build:desktop:prod && cross-env CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win -c.extraMetadata.buildChannel=prod",
    "publish:win:dev": "npm run build:desktop:dev && cross-env ELECTRON_ENV=dev CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win --publish always -c.extraMetadata.buildChannel=dev",
    "publish:win:test": "npm run build:desktop:test && cross-env ELECTRON_ENV=test CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win --publish always -c.extraMetadata.buildChannel=test",
    "publish:win:prod": "npm run build:desktop:prod && cross-env ELECTRON_ENV=prod CSC_IDENTITY_AUTO_DISCOVERY=false electron-builder --win --publish always -c.extraMetadata.buildChannel=prod",
    "package:mac": "electron-builder --mac",
    "package:linux": "cross-env ELECTRON_ENV=dev electron-builder --linux -c.extraMetadata.buildChannel=dev",
    "package:linux:tar": "rm -rf dist/*.tar.gz dist/test-accelerator && npm run build:desktop:prod && cross-env ELECTRON_ENV=prod electron-builder --linux tar.gz -c.extraMetadata.buildChannel=prod",
    "package:linux:appimage:docker": "docker run --rm --name ta-linux-build -e ELECTRON_ENV=prod --mount type=bind,source=$(pwd),target=/project -w /project electronuserland/electron-builder:latest /bin/bash -lc 'npm ci && npm run build:desktop:prod && npx electron-builder --linux AppImage'",
    "format": "prettier --write \"**/*.{js,mjs,ts,mts,d.ts,html}\" --cache",
    "test": "vitest run",
    "test:ui": "vitest --ui",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint src/**/*.ts",
    "lint:fix": "eslint src/**/*.ts --fix",
    "test:auto": "npx playwright test --project=Chromium",
    "check": "npm run lint && npm run test:coverage && tsc --noEmit"
  },
  "dependencies": {
    "@angular/animations": "^20.3.25",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.25",
    "@angular/compiler": "^20.3.25",
    "@angular/core": "^20.3.25",
    "@angular/forms": "^20.3.25",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.25",
    "@angular/platform-browser-dynamic": "^20.3.25",
    "@angular/router": "^20.3.25",
    "@aws-sdk/client-sqs": "^3.986.0",
    "@primeng/themes": "19.1.4",
    "axios": "1.16.0",
    "chart.js": "4.4.2",
    "dotenv": "^17.2.3",
    "electron-updater": "^6.8.3",
    "exceljs": "^4.4.0",
    "express": "4.22.2",
    "interceptor": "^0.1.4",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "moment": "^2.30.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "rxjs": "^7.8.1",
    "tailwindcss-primeui": "^0.5.1",
    "tslib": "^2.6.2",
    "uuid": "14.0.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.30",
    "@angular/cli": "^20.3.30",
    "@angular/compiler-cli": "^20.3.25",
    "@playwright/test": "^1.48.0",
    "@tailwindcss/postcss": "^4.0.0",
    "@types/express": "^4.17.21",
    "@types/node": "^24.10.1",
    "@typescript-eslint/eslint-plugin": "^8.34.1",
    "@typescript-eslint/parser": "^8.34.1",
    "@vitest/coverage-v8": "^3.2.4",
    "autoprefixer": "^10.4.20",
    "concurrently": "^8.2.2",
    "cross-env": "^10.1.0",
    "electron": "39.8.8",
    "electron-builder": "24.13.3",
    "eslint": "^9.29.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "eslint-plugin-security": "^3.0.1",
    "jsdom": "^26.1.0",
    "postcss": "^8.4.49",
    "prettier": "^3.0.0",
    "rimraf": "^6.1.3",
    "tailwindcss": "^3.4.17",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3",
    "vitest": "^3.2.4",
    "wait-on": "^7.2.0"
  },
  "overrides": {
    "@angular-devkit/core": {
      "ajv": ">=8.17.2"
    },
    "picomatch": ">=4.0.4",
    "vite": ">=6.4.2",
    "rollup": ">=4.58.1",
    "webpack": ">=5.105.0",
    "serialize-javascript": ">=7.0.5",
    "tar": ">=7.5.11",
    "@tootallnate/once": ">=3.0.1"
  },
  "author": "ERPA",
  "build": {
    "appId": "com.testaccelerator.app",
    "productName": "Test Accelerator",
    "icon": "src/assets/images/erpa-logo-one2.png",
    "directories": {
      "output": "dist",
      "buildResources": "assets"
    },
    "files": [
      "dist/test-accelerator/**/*",
      "electron.main.js",
      "preload.js",
      "package.json",
      "recording-handlers.js",
      "preload-browserview.js",
      "bedrock-handlers.js"
    ],
    "win": {
      "icon": "src/assets/images/erpa-logo-one2.png",
      "target": [
        {
          "target": "nsis",
          "arch": [
            "x64"
          ]
        },
        {
          "target": "portable",
          "arch": [
            "x64"
          ]
        },
        {
          "target": "zip",
          "arch": [
            "x64"
          ]
        }
      ],
      "publisherName": "ERPA",
      "verifyUpdateCodeSignature": false,
      "sign": null
    },
    "linux": {
      "target": [
        "AppImage"
      ],
      "category": "Development",
      "icon": "src/assets/images/erpa-logo-one2.png",
      "artifactName": "${name}-${version}-${arch}.${ext}",
      "executableName": "test-accelerator"
    },
    "nsis": {
      "oneClick": false,
      "allowToChangeInstallationDirectory": true,
      "createDesktopShortcut": true,
      "createStartMenuShortcut": true,
      "differentialPackage": true
    },
    "publish": [
      {
        "provider": "s3",
        "bucket": "tac-desktop-releases",
        "region": "us-east-1",
        "path": "${env.ELECTRON_ENV}",
        "acl": null
      }
    ]
  }
}
